// extracted by mini-css-extract-plugin
export default {"CreateForm":"CreateForm_CreateForm__y-mwX"};